import { render, staticRenderFns } from "./marketersDataB.vue?vue&type=template&id=21500f8f&scoped=true"
import script from "./marketersDataB.vue?vue&type=script&lang=js"
export * from "./marketersDataB.vue?vue&type=script&lang=js"
import style0 from "./marketersDataB.vue?vue&type=style&index=0&id=21500f8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21500f8f",
  null
  
)

export default component.exports